import {AppConfig} from "@/app/config/AppConfig";
import Util from "@/Master/Util";

const config: AppConfig = {
    productId: 210,
    releaseProductId: 70055,
    ia_host: "xtg-test.kingsna.com",

    adjust_app_token: "5zimqejfxmyo",
    adjust_event_token: "mhdmrw",
    game_event_token_config: "purchase_complete,79j0rq|first_purchase,cxgbsl",
    adjust_environment: "production",//production 或 sandbox
    adjust_logLevel: "info",

    productVersion: '_PWA_VERSION_',//动态生成的版本号

    privacy_url: "https://tangiertussle.com/accord.html",
    trems_url: "https://tangiertussle.com/utilisation.html",
    sweepstakes_rules_url: "https://onegamedeveloper.com/uncti/menyapu-aturan.html",
    responsible_play_url: "https://onegamedeveloper.com/uncti/bertanggung_jawab.html",
    game_statement: "https://onegamedeveloper.com/uncti/pernyataan-permainan.html",
    mail: "onedevgame.pteltd@gmail.com",

    game_api_url: "https://test-hs-back.winjoy99.com",
    nat_host: "test-sdk.letswinjoy.com",
    forterId: "5622bde77f38",

    h5_version_code: 1,
    h5_version_name: '1',
    h5_app_name: '80052',
    h5_package_name: "ifitness.home.workout.body.exercise",
    h5_host_name: Util.isWindow ? window.location.host : '',

    h5_mode: 1,//0默认PWA模式 1直接进入游戏模式
    h5_res_host: "https://oss-gz-sc-zydown.oss-accelerate.aliyuncs.com/SlotGameCenterH5/",
    // h5_res_host: "https://unity.fk321.com/SlotGameCenterH5/",
    h5_res_ver: "webgl/version_1/",

    GTM_ID: "GTM-WM62D6B6",

    feiShuApi: "https://open.feishu.cn/open-apis/bot/v2/hook/5c19f57c-4c46-4593-9ca0-ef1853fed9a3",

    sm_businessId: "h5_ssixdfckjn",
    sm_apiKey: "mmvs96w163hkk05f335ykghk4bbb8ljtosr0",
};

export default config; // 确保有默认导出
